
export class SharedStrings {
    static readonly SUPPORT_EMAIL = 'help@colonist.io'
    static readonly DISCORD_CHANNEL = 'https://discord.gg/colonist'
    static readonly DISCORD_SERVER_ID = '605233308577562643'
    static readonly BLOG_URL = 'https://blog.colonist.io'
    static readonly FEATURE_UPVOTE_URL = 'https://colonist.featureupvote.com'
}
